import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-shopping-bag-line text-sm" />
              </span>
              <span className="text-lg font-semibold font-heading text-foreground-950">
                Kakobuy Polska
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Największa lista najlepszych produktów z Chin dla polskich kupujących. Aktualne linki, porównania cen i bezpieczne zakupy.
            </p>
            <div className="flex items-center gap-3 pt-2">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors"
                aria-label="Spreadsheet"
              >
                <i className="ri-external-link-line" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 uppercase tracking-wider mb-4">
              Kategorie
            </h4>
            <ul className="space-y-2">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 uppercase tracking-wider mb-4">
              Więcej kategorii
            </h4>
            <ul className="space-y-2">
              {categories.slice(7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 uppercase tracking-wider mb-4">
              Nawigacja
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  {t('nav_home')}
                </Link>
              </li>
              <li>
                <Link to="/blog/kakobuy-spreadsheet-polska-guide-2026/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  {t('nav_guides')}
                </Link>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                >
                  {t('cta_spreadsheet')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            {t('footer_copyright')}
          </p>
          <p className="text-xs text-foreground-400 text-center sm:text-right max-w-md">
            {t('footer_disclaimer')}
          </p>
        </div>
      </div>
    </footer>
  );
}